import {API_URLS} from '@/const';
import {http} from '@/helper';

export const investmentApi = {
  getProduct(query) {
    return http.get(API_URLS.INVESTMENT_PRODUCT, {query});
  },
  getProductOnly() {
    return http.get(API_URLS.INVESTMENT_PRODUCT_ONLY, {});
  },
  getProductActivity(query) {
    return http.get(API_URLS.PRODUCT_ACTIVITY, {query});
  },
  accountInfo() {
    return http.get(API_URLS.INVESTMENT_ACCOUNT_INFO, {});
  },
  orderList(query) {
    return http.get(API_URLS.INVESTMENT_ORDER, {query});
  },
  onOffAutoRenew(params) {
    return http.post(API_URLS.INVESTMENT_ORDER_AUTORENEW, {params});
  },
  investmentTransfer(params) {
    return http.post(API_URLS.INVESTMENT_TRANSFER, {params});
  },
  buyInvestment(params) {
    return http.post(API_URLS.INVESTMENT_BUY, {params});
  },
  getAccountFlow(query) {
    return http.get(API_URLS.INVESTMENT_JOURNAL, {query});
  },
  getBonusHistory(query) {
    return http.get(API_URLS.INVESTMENT_BONUS_HISTORY, {query});
  },
  getBonusList() {
    return http.get(API_URLS.INVESTMENT_BONUS_LIST, {});
  },
  getAccountList() {
    return http.get(API_URLS.INVESTMENT_ACCOUNT_LIST, {});
  },
  getMyEarningsList(query) {
    return http.get(API_URLS.INVESTMENT_MY_EARNINGS_LIST, {query});
  },
  getOrderHistoryList(query) {
    return http.get(API_URLS.INVESTMENT_ORDER_HISTORY_LIST, {query});
  },
  getOrderLaunchHistoryList(query) {
    return http.get(API_URLS.LAUNCHPOOL_FUNDS, {query});
  },
  getSettlementHistoryList(query) {
    return http.get(API_URLS.INVESTMENT_SETTLEMENT_HISTORY_LIST, {query});
  },
  getSettlementLaunchHistoryList(query) {
    return http.get(API_URLS.LAUNCHPOOL_REBATE_CLAIMED_LIST, {query});
  },
  onTimedRedemption(params) {
    return http.post(API_URLS.INVESTMENT_TIMED_REDEMPTION, {params});
  },
  getAccountActivity(query) {
    return http.get(API_URLS.ACCOUNT_ACTIVITY, {query});
  },
  postAccountAssetConfig(params) {
    return http.post(API_URLS.ACCOUNT_ASSET_CONFIG, {params});
  },
  changeAutoMatic(params) {
    return http.post(API_URLS.EARN_CRYPTO_AUTO_MATIC, {params});
  },
  isEarnCryptoNewUser() {
    return http.get(API_URLS.EARN_CRYPTO_NEW_USER, {});
  },
};
